import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { UserSessionApiService } from '@services';
import { UserDataService } from '@services';

import { WINDOW } from '../../../core/window.token';

@Component({
  selector: 'logout-component',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {
  @Input() email = '';
  @Output() signedOut = new EventEmitter<void>();

  private window = inject(WINDOW);
  private userDataService = inject(UserDataService);
  private userSessionApiService = inject(UserSessionApiService);

  onSignOut(): void {
    const returnUrl = this.window.location.href;
    this.userDataService.clearUserData();
    this.signedOut.emit();
    this.userSessionApiService.logout(returnUrl);
  }
}
